import { Routes, Route} from "react-router-dom";

import LoginPage from './pages/LoginPage'
import Home from './pages/Home'
import Provision from "./pages/Provision";
import AppNavbar from "./components/AppNavbar";
import AppConfiguration from "./components/AppConfiguration";
import {AuthProvider} from "./components/auth/AuthProvider";
import {ProtectedRoute} from "./components/auth/ProtectedRoute";

import {Container} from "react-bootstrap";
import {AppContextProvider} from "./components/AppContext";
import {DebugPage} from "./pages/DebugPage";
import {OperateMachine} from "./pages/OperateMachine";
import {Machines} from "./pages/Machines";
import {MachinesReportPage} from "./pages/MachinesReport";
import {ROUTES} from "./routes"
import ProfilePage from "./pages/ProfilePage";

function App() {

    // const [token, setToken] = useState(null);

    // const confirmAuth = (_token) => {
    //     setToken(_token);
    // }

    return (
    <>
        <AppContextProvider>
            <AuthProvider>
                    <Routes>
                        <Route path={ROUTES.HOME} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container className={"p-3"}>
                                    <Home />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.PROVISION} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container className={"p-3"}>
                                    <Provision />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.OPERATE_MACHINE} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container className={"p-3"}>
                                    <OperateMachine />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.MACHINES} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container fluid className={"p-3"}>
                                    <Machines />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.MACHINES_REPORT} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container fluid className={"p-3"}>
                                    <MachinesReportPage />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.LOGIN} element={<LoginPage />} />

                        <Route path={ROUTES.PROFILE} element={
                            <ProtectedRoute>
                                <AppNavbar/>
                                <Container fluid className={"p-3"}>
                                    <ProfilePage />
                                </Container>
                            </ProtectedRoute>
                        } />

                        <Route path={ROUTES.DEBUG} element={
                            <Container className={"p-3"}>
                                <DebugPage />
                            </Container>
                        } />


                    </Routes>
            </AuthProvider>
        </AppContextProvider>
    </>
    );
}

export default App;
